import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url.pipe';

import { Attraction } from 'src/app/core/types/models/attraction.model';
import { LocationListModule } from 'src/app/shared/location-list/location-list.module';

import { AttractionInfoComponent } from 'src/app/shared/used-components/attraction-info/attraction-info.component';

@Component({
  selector: 'app-attraction-card-mobile',
  templateUrl: './attraction-card-mobile.component.html',
  styleUrls: ['attraction-card-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, LocationListModule, SafeUrlPipe],
})
export class AttractionCardMobileComponent {
  @Input() countryName: string = '';
  @Input() attraction: Attraction | null = null;

  constructor(private readonly dialog: MatDialog) {}

  public handleShowAttraction(ev: Event): void {
    ev.stopPropagation();

    this.dialog.open(AttractionInfoComponent, {
      width: '592px',
      maxWidth: '96vw',
      maxHeight: '96%',
      data: {
        title: this.attraction.name,
        imageUrl: this.attraction.imageUrl,
        description: this.attraction.shortDescription,
      },
    });
  }
}
